import * as React from "react";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
const PagerDutyNotificationDetails = ({ notification }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("pager_duty_notification_details.routing_key_label"),
      value: (_a = notification.config) == null ? void 0 : _a.routing_key
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("pager_duty_notification_details.incident_title_label"),
      value: (_b = notification.config) == null ? void 0 : _b.pager_duty_title
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("pager_duty_notification_details.custom_incident_label"),
      value: (_c = notification.config) == null ? void 0 : _c.custom_incident
    }
  ), ((_d = notification == null ? void 0 : notification.config) == null ? void 0 : _d.custom_incident) && ((_e = notification.config) == null ? void 0 : _e.key_prefix) && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("pager_duty_notification_details.key_prefix_label"),
      value: (_f = notification.config) == null ? void 0 : _f.key_prefix
    }
  ), ((_g = notification == null ? void 0 : notification.config) == null ? void 0 : _g.custom_incident) && ((_h = notification.config) == null ? void 0 : _h.incident_key) && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("pager_duty_notification_details.incident_key_label"),
      value: (_i = notification.config) == null ? void 0 : _i.incident_key
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("pager_duty_notification_details.client_name_label"),
      value: (_j = notification.config) == null ? void 0 : _j.client_name
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("pager_duty_notification_details.client_url_label"),
      value: (_k = notification.config) == null ? void 0 : _k.client_url
    }
  ));
};
export default PagerDutyNotificationDetails;
